module.exports = __webpack_public_path__ + "static/media/AlmeneAndre.9ad687d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Courses/AlmeneAndre.jpg
// module id = 1527
// module chunks = 0